module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./ShareProductsView.js"));
	}, "ShareProductsView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ShareProductsView!./src/pages/Shop/ShareProducts/ShareProductsView.js
// module id = 1789
// module chunks = 367